<div class="ui-control-grade-delete">
  <img src="assets/images/shapes/warning.png" alt="">
  <div class="ui-control-grade-delete-text">Are you sure want to delete?</div>
  <div class="ui-control-grade-delete-actions">
    <button class="ui-control-grade-delete-action-no" (click)="actionClose()">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
      </svg>
      <span>Cancel</span>
    </button>
    <button class="ui-control-grade-delete-action-yes" (click)="actionConfirm()">
      <svg  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      <span>Yes, delete</span>
    </button>
  </div>
</div>
